/* @ngInject */
export default function LightHeaderController(
  CurrentCourseManager,
) {
  const vm = this;
  vm.currentCourseManager = CurrentCourseManager;
}
